import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7006b6a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-intent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Enter", -1))
const _hoisted_3 = { class: "examples-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Erweiterte Einstellungen", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "keyboard_arrow_down", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "advanced-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_hint = _resolveComponent("md-hint")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_input_field, {
      variant: "outlined",
      modelValue: _ctx.example,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.example) = $event)),
      label: "Neuen Ausdruck hinzufügen",
      error: false,
      onKeydown: _ctx.exampleKeyDown,
      size: "small"
    }, null, 8, ["modelValue", "onKeydown"]),
    _createVNode(_component_md_hint, { icon: "info" }, {
      default: _withCtx(() => [
        _createTextVNode(" Drücke "),
        _hoisted_2,
        _createTextVNode(" um einen Ausdruck hinzuzufügen. ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      ((_ctx.rows && _ctx.rows.length > 0) || _ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_md_table, {
            key: 0,
            rows: _ctx.rows,
            onButtonClick: _ctx.handleTableButtonClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_table_column, {
                title: "Phrase",
                display: "text"
              }),
              _createVNode(_component_md_table_column, {
                title: "Score",
                display: "score",
                type: "badge",
                numeric: true
              }),
              _createVNode(_component_md_table_column, {
                title: "",
                display: "delete",
                type: "button"
              })
            ]),
            _: 1
          }, 8, ["rows", "onButtonClick"]))
        : (_openBlock(), _createBlock(_component_empty_hint, {
            key: 1,
            variant: "inline",
            title: 'Keine Ausdrücke für ' + _ctx.languageName + ' hinzugefügt',
            description: "Gebe oben im Eingabefeld einen Ausdruck ein und drücke anschließend Enter, um diesen hinzuzufügen."
          }, null, 8, ["title"]))
    ]),
    _createVNode(_component_md_card, {
      variant: "outlined",
      class: "advanced"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["header", { active: _ctx.advancedSettingsOpen }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.advancedSettingsOpen = !_ctx.advancedSettingsOpen))
        }, _hoisted_6, 2),
        (_ctx.advancedSettingsOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_md_checkbox, {
                modelValue: _ctx.intelligentEnquireActive,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.intelligentEnquireActive) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Intelligentes Nachfragen für dieses FAQ-Paar aktivieren. ")
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_md_input_field, {
                variant: "outlined",
                modelValue: _ctx.intelligentEnquireQuestion[_ctx.language],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.intelligentEnquireQuestion[_ctx.language]) = $event)),
                label: "Nachfrage für diese Intention",
                error: false,
                disabled: !_ctx.intelligentEnquireActive,
                size: "small"
              }, null, 8, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}